import {NextURL} from 'next/dist/server/web/next-url';
import {BASE_PATH} from './getAppRoute';

export function isTrustedUrl<T extends string | NextURL>(
  url: T
): {trusted: boolean; url: T} {
  try {
    const parsedUrl = new URL(url as string);
    if (parsedUrl.protocol !== 'https:' && parsedUrl.protocol !== 'http:') {
      return {trusted: false, url};
    }
    return {trusted: true, url};
    // Ensure the hostname is in a whitelist of allowed domains
    // const allowedDomains = ['example.com', 'anotherdomain.com'];
    // if (!allowedDomains.includes(parsedUrl.hostname)) {
    //   return false;
    // }
  } catch (e) {
    return {trusted: false, url};
  }
}

export const isTrustedRoutesUrl = (url: string) => {
  try {
    // Attempt to create a new URL object
    const parsedUrl = new URL(url as string);
    if (parsedUrl.protocol !== 'https:' && parsedUrl.protocol !== 'http:') {
      return {trusted: false, url};
    }
    return {trusted: true, url};
  } catch (e) {
    const localeArr = ['en', 'ar', 'ru'];
    const pathSplit = url.split('/').filter(Boolean);
    if (pathSplit.length > 1) {
      const [locale, pathname] = pathSplit;
      let isAppPath = BASE_PATH.some((route) => pathname === route);
      if (localeArr.includes(locale) && isAppPath) return {trusted: true, url};
      else return {trusted: false, url};
    }
    return {trusted: false, url};
  }
};
